/**
 * Created by idea on 20/03/2017.
 */
import { Injectable } from '@angular/core';
import { Headers, Http, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';

@Injectable()
export class ApiIcheckService {
    private header: Headers;
    private endPoint: string;

    constructor(private http: Http, private router: Router) {
        let contentHeaders = new Headers();
        this.header = contentHeaders;
        if (localStorage.getItem('Access-Token-Icheck')) {
            this.header.set('Access-Token', localStorage.getItem('Access-Token-Icheck'));
        }
    }

    public setHeader(key: string, value: string): ApiIcheckService {
        this.header.set(key, value);
        return this;
    }

    public setEndPoint(s: string) {
        this.endPoint = s;
    }

    get(url: string, options?: any): Observable<any> {
        let params = new URLSearchParams();
        if (typeof options === 'object') {
            for (var i in options) {
                params.set(i, options[i]);
            }
        }
        this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
        return this.http.get(environment.apiIcheck + url, { headers: this.header, search: params })
            .map((res: any) => {
                return this.check(res);
            })
            .catch((error: any) => Observable.throw(error || 'Server error'));
    }

    post(url: string, body?: any): Observable<any> {
        this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
        return this.http.post(environment.apiIcheck + url, body, { headers: this.header })
            .map((res: Response) => {
                return this.check(res);
            })
            .catch((error: any) => Observable.throw(error || 'Server error'));
    }

    put(url: string, body?: any): Observable<any> {
        this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
        return this.http.put(environment.apiIcheck + url, body, { headers: this.header })
            .map((res: Response) => { return this.check(res); })
            .catch((error: any) => Observable.throw(error || 'Server error'));
    }

    delete(url: string, options?: any): Observable<any> {
        this.header.set('Accept-Language', localStorage.getItem('lang') || 'vi');
        return this.http.delete(environment.apiIcheck + url, { headers: this.header, search: options })
            .map((res: Response) => {
                return this.check(res);
            })
            .catch((error: any) => Observable.throw(error || 'Server error'));
    }

    all(data?: {}) {
        return this.get(this.endPoint, data);
    }

    find(id, data?: {}) {
        return this.get(this.endPoint + "/" + id, data);
    }

    add(data: {}) {
        return this.post(this.endPoint, data);
    }

    update(id, data: {}) {
        return this.put(this.endPoint + "/" + id, data);
    }

    remove(id, data?: {}) {
        return this.delete(this.endPoint + "/" + id, data);
    }

    check(res) {
        var response = res.json();
        if (response.status == 200) {
            return response.data;
        } else if (response.status == 402 || response.status == 401) {
            // localStorage.removeItem('Access-Token-Icheck');
            // localStorage.clear();
            this.router.navigate(['/']);
            throw response;
        } else if (response.status == 404) {
            response.error = 'empty data';
            throw response;
        } else {
            throw response;
        }
    }


}


// WEBPACK FOOTER //
// /app/src/app/common/services/ApiIcheck.service.ts